<template>
  <div>
    <a-modal v-model="visible" title="Edit Route" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="savedata">Update</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Route No." class="mb-2">
              <a-input placeholder="Route No."
            v-decorator="['route_no', { rules: [{ required: true, message: 'Please input route no.!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Route Name">
              <a-input placeholder="Route Name"
            v-decorator="['route_name', { rules: [{ required: true, message: 'Please input route name.!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
            </a-form-item>
          </div>
        </div>

        <a-form-item label="Location of the route">
          <a-textarea placeholder="Location of the route" :autosize="{ minRows: 2 }"
            v-decorator="['location', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
        </a-form-item>
        <a-form-item label="Remark">
          <a-textarea placeholder="Remark" :autosize="{ minRows: 2 }"
            v-decorator="['remark', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'EditRoute',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      routes: [],
      oldrecord: {},
    }
  },
  mounted: function () {
    this.$eventBus.$on('openEditForm', this.showForm)
  },
  watch: {
    formVisible: function (n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    showForm: function (record) {
      console.log('Record', record)
      this.visible = true
      this.oldrecord = record
      setTimeout(() => {
        this.form.setFieldsValue({
          route_no: record.route_no,
          route_name: record.route_name,
          location: record.location,
          remark: record.remark,
        })
      }, 50)
    },
    savedata: function () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // clearform(this.form)
          console.log('route_id: ', values.route_id)
          this.$confirm({
            title: `Are you sure you want to edit the roue with route no. ${values.route_no}?`,
            content: `Click on the OK button to edit the route!`,
            onOk: () => {
              this.$http.patch(`/api/transport/route/${this.oldrecord.id}`, {
                route_no: values.route_no,
                route_name: values.route_name,
                location: values.location,
                remark: values.remark,
              })
                .then((resp) => {
                  if (resp.status === 200 || resp.status === 201) {
                    this.loading = false
                    this.visible = false
                    this.$emit('onEdited')
                    this.$notification['success']({
                      message: resp.data.message.success,
                      description: `Route with route no. ${values.route_no} updated successfully!`,
                    })
                    console.log('response: ', resp)
                    // this.showInwardTransactionModal(resp.data.data)
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>

<style></style>
